import * as React from 'react';

/**
 * Servwell patch (101): the app switches chrome at lg — Tailwind v4's `--breakpoint-lg`,
 * i.e. 64rem — and theme.css spells out at length why this must be a REM query, never
 * 1024px: at any root font size other than 16px a px query opens a band where the mobile
 * bar is drawn while the desktop sidebar also renders (or neither does), and the "Open
 * menu" button toggles a sidebar the user cannot see. `64rem` here mirrors `lg:hidden`
 * on the one sticky bar exactly, at every root font size. Sonar upstream uses 768px.
 */
export const MOBILE_QUERY = '(max-width: 63.999rem)';

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = () => {
      setIsMobile(mql.matches);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isMobile;
}
